import { getCookie } from "utils/cookie";

export const Get = async (path) => {
    const token = getCookie("token");
    const headers = {
        "Accept": "application/json",
        ...(token && {"Authorization": "Bearer " + token})
    }

    let response = await fetch(path, {
        method: "GET",
        headers: headers
    })
    .then(async (res) => await res.json())
    .catch(err => console.log("Error to get: " + err.message));

    return response;
}

export const Post = async (path, body) => {
    const token = getCookie("token");
    const headers = {
        "Accept": "application/json",
        ...(!(body instanceof FormData) && {"Content-type": "application/json"}),
        ...(token && {"Authorization": "Bearer " + token})
    };
    
    let httpCode;
    let response = await fetch(path, {
        method: "POST",
        headers: headers,
        body: body
    })
    .then(async (res) => {
        httpCode = res.status;
        return await res.json();
    })
    .catch(err => console.log("Error to post: " + err.message));

    response["httpCode"] = httpCode;
    return response;
}

export const Put = async (path, body) => {
    const headers = {
        "Accept": "application/json",
        ...(!(body instanceof FormData) && {"Content-type": "application/json"})
    }

    let response = await fetch(path, {
        method: "PUT",
        headers: headers,
        body: body
    })
    .then(async (res) => await res.json())
    .catch(err => console.log("Error to put: " + err.message));

    return response;
}

export const Patch = async (path, body) => {
    const headers = {
        "Accept": "application/json",
        ...(!(body instanceof FormData) && {"Content-type": "application/json"})
    }
    
    let response = await fetch(path, {
        method: "PATCH",
        headers: headers,
        body: body
    })
    .then(async (res) => await res.json())
    .catch(err => console.log("Error to patch: " + err.message));

    return response;
}

export const Delete = async (path, body) => {
    const headers = {
        "Accept": "application/json",
        "Content-type": "application/json"
    }

    let response = await fetch(path, {
        method: "DELETE",
        headers: headers,
        body: body
    })
    .then(async (res) => await res.json())
    .catch(err => console.log("Error to delete: " + err.message));

    return response;
}